import Vue from "vue";
import Router from "vue-router";
// 首页
const Home = resolve => require(["views/Home.vue"], resolve);
//404页面
const notfound = resolve => require(["views/404.vue"], resolve);
const download = resolve => require(["views/download.vue"], resolve);
// 登录页
const Login = resolve => require(["views/account/login.vue"], resolve);
const loginLoading = resolve =>
  require(["views/account/loginLoading.vue"], resolve);
//手机号验证码
const phoneLogin = resolve =>
  require(["views/account/phoneLogin.vue"], resolve);
const bindPhone = resolve => require(["views/account/bindPhone.vue"], resolve);
// 注册页
const register = resolve => require(["views/account/register.vue"], resolve);
// 忘记密码、更改密码
const forget = resolve => require(["views/account/forget.vue"], resolve);
// 福利
const welfare = resolve => require(["views/mainpage/welfare.vue"], resolve);
// 书库
const bookStack = resolve => require(["views/mainpage/bookStack.vue"], resolve);
// 出版
const publishBook = resolve =>
  require(["views/mainpage/publishBook.vue"], resolve);
/* 关于 */
// 用户注册协议
const userAgree = resolve => require(["views/about/userAgree.vue"], resolve);
const privacy = resolve => require(["views/about/privacy.vue"], resolve);
// 个人中心
const personal = resolve => require(["views/personal/personal.vue"], resolve);
const center = resolve => require(["views/personal/center.vue"], resolve);
const setmyinfo = resolve => require(["views/personal/setting.vue"], resolve);
const collect = resolve => require(["views/personal/collectBook.vue"], resolve);
const myAccount = resolve => require(["views/personal/myAccount.vue"], resolve);
const alipay = resolve => require(["views/personal/alipay.vue"], resolve);
const rechargeRecord = resolve =>
  require(["views/personal/rechargeRecord.vue"], resolve);
const expenseRecord = resolve =>
  require(["views/personal/expenseRecord.vue"], resolve);
const recordDetail = resolve =>
  require(["views/personal/recordDetail.vue"], resolve);
const accountDetail = resolve =>
  require(["views/personal/accountDetail.vue"], resolve);
const userMessage = resolve => require(["views/personal/message.vue"], resolve);
// 作品管理
const applyWriter = resolve =>
  require(["views/authorCenter/applyWriter"], resolve);
const authorIndex = resolve => require(["views/authorCenter/index"], resolve);
const authorInfo = resove => require(["views/authorCenter/authorInfo"], resove);
const authorIncome = resove => require(["views/authorCenter/income"], resove);
const chapterManage = resolve =>
  require(["views/authorCenter/secondLevel/index"], resolve);
const published = resolve =>
  require(["views/authorCenter/secondLevel/published"], resolve);
const authorNewChapter = resolve =>
  require(["views/authorCenter/secondLevel/newChapter"], resolve);
const drafts = resolve =>
  require(["views/authorCenter/secondLevel/drafts"], resolve);
const bookSetting = resolve =>
  require(["views/authorCenter/secondLevel/bookSetting"], resolve);
const sign = resolve =>
  require(["views/authorCenter/secondLevel/sign"], resolve);
const messagecenter = resolve =>
  require(["views/authorCenter/messageCenter"], resolve);

/* 用户模块 */
// 书籍详情
const bookDetail = resolve => require(["views/readPage/detail"], resolve);
// 目录
const catalog = resolve => require(["views/readPage/catalog"], resolve);
// 章节内容
const chapter = resolve => require(["views/readPage/chapter"], resolve);
Vue.use(Router);
import { getToken } from "utils/storage";
import { getwriter } from "utils/storage";
const router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/home",
      name: "home",
      component: Home,
      meta: {
        keepAlive: true,
        title: "源石阅读-小说阅读网|好看的小说|小说推荐"
      }
    },
    {
      path: "*",
      name: "notfound",
      component: notfound,
      meta: {
        keepAlive: true,
        title: "页面不存在"
      }
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        keepAlive: true,
        title: "登录-源石阅读"
      }
    },
    {
      path: "/loginLoading/qq",
      name: "loginLoading",
      alias: "/loginLoading/wx",
      component: loginLoading,
      meta: {
        keepAlive: false,
        title: "正在登录-源石阅读"
      }
    },
    {
      path: "/",
      name: "phoneLogin",
      component: phoneLogin,
      meta: {
        keepAlive: false,
        title: "手机号登录-源石阅读"
      }
    },
    {
      path: "/bindPhone",
      name: "bindPhone",
      component: bindPhone,
      meta: {
        keepAlive: true,
        title: "绑定手机号-源石阅读"
      }
    },
    {
      path: "/register",
      name: "register",
      component: register,
      meta: {
        keepAlive: false,
        title: "注册-源石阅读"
      }
    },
    {
      path: "/forget",
      name: "forget",
      component: forget,
      meta: {
        keepAlive: false,
        title: "忘记密码-源石阅读"
      }
    },
    {
      path: "/userAgree",
      name: "userAgree",
      component: userAgree,
      meta: {
        keepAlive: true,
        title: "注册协议"
      }
    },
    {
      path: "/privacy",
      name: "privacy",
      component: privacy,
      meta: {
        keepAlive: true,
        title: "隐私协议"
      }
    },
    {
      path: "/download",
      name: "download",
      component: download,
      meta: {
        keepAlive: true,
        title: "下载"
      }
    },
    {
      path: "/welfare",
      name: "welfare",
      component: welfare,
      meta: {
        keepAlive: true,
        title: "福利-源石阅读"
      }
    },
    {
      path: "/publishBook",
      name: "publishBook",
      component: publishBook,
      meta: {
        keepAlive: true,
        title: "出版-源石阅读"
      }
    },
    {
      path: "/bookStack",
      name: "bookStack",
      component: bookStack,
      meta: {
        keepAlive: true,
        title: "书库-源石阅读"
      }
    },
    {
      path: "/applyWriter",
      name: "applyWriter",
      component: applyWriter,
      meta: {
        keepAlive: false,
        title: "申请-源石阅读"
      }
    },
    {
      path: "/bookDetail/:id",
      name: "book",
      component: bookDetail,
      meta: {
        keepAlive: false,
        islogin: false,
        title: "书籍详情-源石阅读"
      }
    },
    {
      path: "/list/:id",
      name: "catalog",
      component: catalog,
      meta: {
        keepAlive: false,
        islogin: false,
        title: "目录-源石阅读"
      }
    },
    {
      path: "/book/:id/:chapterid",
      name: "chapter",
      component: chapter,
      meta: {
        keepAlive: false,
        islogin: false,
        title: "章节-源石阅读"
      }
    },
    {
      path: "/personal",
      name: "personal",
      component: personal,
      redirect: "/personal/center",
      meta: {
        keepAlive: true,
        islogin: true,
        name: "个人中心",
        title: "个人中心-源石阅读"
      },
      children: [
        {
          path: "center",
          name: "center",
          component: center,
          meta: {
            keepAlive: false,
            islogin: true,
            name: "我的信息",
            title: "我的信息-源石阅读"
          },
          children: [
            {
              path: "set",
              name: "set",
              component: setmyinfo,
              meta: {
                keepAlive: false,
                islogin: true,
                name: "设置",
                title: "设置-源石阅读"
              }
            }
          ]
        },
        {
          path: "collect",
          name: "collect",
          component: collect,
          meta: {
            keepAlive: false,
            islogin: true,
            name: "我的收藏",
            title: "我的收藏-源石阅读"
          }
        },
        {
          path: "message",
          name: "userMessage",
          component: userMessage,
          meta: {
            islogin: true,
            keepAlive: false,
            name: "消息通知",
            title: "消息通知-源石阅读"
          }
        },
        {
          path: "myAccount",
          name: "myAccount",
          component: myAccount,
          meta: {
            islogin: true,
            keepAlive: false,
            name: "我的账户",
            title: "我的账户-源石阅读"
          },
          children: [
            {
              path: "rechargeRecord",
              name: "rechargeRecord",
              component: rechargeRecord,
              meta: {
                islogin: true,
                keepAlive: false,
                name: "充值记录",
                title: "充值记录-源石阅读"
              }
            },
            {
              path: "expenseRecord",
              name: "expenseRecord",
              component: expenseRecord,
              meta: {
                islogin: true,
                keepAlive: false,
                name: "消费记录",
                title: "消费记录-源石阅读"
              },
              children: [
                {
                  path: "detail",
                  name: "recordDetail",
                  component: recordDetail,
                  meta: {
                    islogin: true,
                    keepAlive: false,
                    name: "书籍详情",
                    title: "消费详情-源石阅读"
                  },
                  children: [
                    {
                      path: "account",
                      name: "accountDetail",
                      component: accountDetail,
                      meta: {
                        islogin: true,
                        keepAlive: false,
                        name: "明细",
                        title: "消费明细-源石阅读"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      path: "/alipay",
      name: "alipay",
      component: alipay,
      meta: {
        keepAlive: false,
        islogin: true,
        title: "支付宝支付"
      }
    },
    {
      path: "/author",
      name: "作品专区",
      component: authorIndex,
      meta: {
        // keepAlive: true,
        islogin: true,
        isAuthor: true,
        title: "作品管理-源石阅读"
      },
      children: [
        {
          path: "info",
          name: "作者资料",
          component: authorInfo,
          meta: {
            title: "作者资料-源石阅读",
            isAuthor: true
          }
        },
        {
          path: "income",
          name: "作品收入",
          component: authorIncome,
          meta: {
            title: "作品收入-源石阅读",
            isAuthor: true
          }
        },
        {
          path: "message",
          name: "消息中心",
          component: messagecenter,
          meta: {
            title: "消息中心-源石阅读",
            isAuthor: true
          }
        }
      ]
    },
    {
      path: "/authorManage",
      name: "作品管理",
      component: chapterManage,
      redirect: "/author",
      meta: {
        // keepAlive: true,
        islogin: true,
        isAuthor: true,
        title: "作品管理-源石阅读"
      },
      children: [
        {
          path: "newChapter/:id",
          name: "新建章节",
          component: authorNewChapter,
          meta: {
            title: "新建章节-源石阅读",
            isAuthor: true
          }
        },
        {
          path: "drafts/:id",
          name: "草稿箱",
          component: drafts,
          meta: {
            title: "草稿箱-源石阅读",
            isAuthor: true
          }
        },
        {
          path: "published/:id",
          name: "已发布章节",
          component: published,
          meta: {
            title: "已发布章节-源石阅读",
            isAuthor: true
          }
        },
        {
          path: "bookSetting/:id",
          name: "作品设置",
          component: bookSetting,
          meta: {
            title: "作品设置-源石阅读",
            isAuthor: true
          }
        },
        {
          path: "sign/:id",
          name: "签约信息",
          component: sign,
          meta: {
            title: "签约信息-源石阅读",
            isAuthor: true
          }
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.meta.islogin && !getToken()) {
    //true则需要登录
    next({
      name: "phoneLogin",
      query: {
        redirect: to.fullPath
      }
    });
    return;
  } else {
    if (to.meta.isAuthor) {
      if (getwriter() != "true") {
        next({
          name: "applyWriter",
          query: {
            redirect: to.fullPath
          }
        });
      } else {
        next();
      }
    } else {
      next();
    }
    next();
  }
});
export default router;
